$(document).ready(function () {



    $('.product-slider-content').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        infinite: true,
        speed: 1000,
        asNavFor: '.product-slider-thumb',
    });
    $('.product-slider-thumb').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.product-slider-content',
        dots: false,
        centerMode: true,
        focusOnSelect: true
    });
// STYLE CLICK


$('.hover-zoom img').click(function(){
    var img_src = $(this).attr('src');
    $('.zoom-product-img .main-img-product-zoom').attr('src',img_src);
    $('.zoom-product-img').show();
});
$('.zoom-product-img img.close-main-product').click(function(){
    $('.zoom-product-img').hide();
});


    if ($('.infinite-scroll').length) {
        var loading = false,
            next_wrapper = $('.infinite-scroll');

        $(window).scroll(function () {
            if (next_wrapper.offset().top <= $(window).scrollTop() + $(window).height() && !loading) {
                loading = true;
                var next_link = next_wrapper.find('.next a').attr('href');

                if (next_link) {
                    $.get(next_link, function (data) {
                        var products = $(data).find('.collection-product-list .product-block:not(.one-half)');

                        $('.infinite-scroll').html($(data).find('.infinite-scroll').html());
                        $('.collection-product-list .grid').append(products);

                        loading = false;
                    });
                }
            }
        });
    }

    var position = $(window).scrollTop();

    $('.site-header .old-switch').addClass('show-old');

    $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll > position) {
            $('.site-header .old-switch').removeClass('show-old');
        } else {
            $('.site-header .old-switch').addClass('show-old');
        }
        position = scroll;
    });

    var status = true;
    var status_checkout = true;

    setInterval(function () {
        if ($('.tabarnapp__image').length && status) {
            $('.tabarnapp__image').each(function () {
                $(this).attr('src', $(this).attr('src').replaceAll('_compact.', "."));
            });

            status = false;
        }
    }, 1000);

    setInterval(function () {
        if ($('.tabarnapp__upsell').length && status_checkout) {
            $('.tabarnapp__upsell-checkout').show();

            status_checkout = false;
        }
    }, 1000);

    $(document).on('click', '.cart-summary__clear', function (e) {
        e.preventDefault();

        $.ajax({
            type: "POST",
            url: '/cart/clear.js',
            success: function () {
                $.get('/search', function (data) {
                    var selectors = [
                        '.page-header .header-cart',
                        '.docked-navigation-container .header-cart'
                    ];

                    var $parsed = $($.parseHTML('<div>' + data + '</div>'));
                    for (var i = 0; i < selectors.length; i++) {
                        var cartSummarySelector = selectors[i];
                        var $newCartObj = $parsed.find(cartSummarySelector).clone();
                        var $currCart = $(cartSummarySelector);
                        $currCart.replaceWith($newCartObj);
                    }
                    theme.checkCurrency();
                });
            },
            dataType: 'json'
        });
    });

    $(document).ready(function () {
        $('[data-product-single-thumbnail-youtube]').magnificPopup({
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
        });
    });

    $(document).on('change', '#HearAboutUs', function (e) {
        var value = $(this).val();

        if (value == 'Other') {
            $('.hear-other').show();
        } else {
            $('.hear-other').hide();
        }
    });

    var calculation = false;

    $(document).on('click', '#fedex-calculate', function (e) {
        e.preventDefault();

        if (calculation == false) {
            calculation = true;

            $('#fedex-loading').show();

            $.get("https://shipping.abex.com/api/calculate", {
                product_id: $('#fedex-product-id').val(),
                zip: $('#fedex-zip').val(),
                variant_id: $('[data-product-select]').val()
            }).done(function (data) {
                var rates_html = '';

                if (data['rates'].length) {
                    var qty_1 = $('select.quantity-proxy').val();
                    $.each(data['rates'], function (key, rate) {
                        console.log(rate);
                        rates_html += '<tr><td>' + rate['service_name'] + '</td><td>$' + parseFloat(Math.round(rate['total_price'].replace(/,/g, '')) * qty_1) + '</td></tr>';
                    });
                } else {
                    rates_html = '<tr><td><b>The product is not shippable to this location</b></td></tr>';
                }

                $('#fedex-result-content').html(rates_html);

                $('#fedex-loading').hide();
                $('#fedex-result').show();
                calculation = false;
            });
        }
    });

    $(document).on('click', '.tabarnapp__upsell .tabarnapp__span_1_of_3 .tabarnapp__image_container', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $(this).toggleClass('active');
    });

});

$(document).on('ready',function(){
         let findiFrame = $('body').find('iframe');
          if($(findiFrame).attr('id') == 'frame'){
            function iframehtml() {
                    var url = 'https://exhibitsearch.abex.com';
                    var xmlhttp = new XMLHttpRequest();
                    xmlhttp.onreadystatechange = function () {
                        if (this.readyState == 4 && this.status == 200) {
                            var myArr = JSON.parse(this.responseText);
                            updatePreview(myArr);
                        }      
                    };
                    xmlhttp.open('GET', document.location.protocol + '//api.allorigins.win/get?url='+url);
                    xmlhttp.send(); 
                    function updatePreview (data) {
                      var iframe = document.getElementById('frame');
                      var doc = iframe.document;
                      
                      if(iframe.contentDocument) {
                        doc = iframe.contentDocument;
                      } else if(iframe.contentWindow) {
                        doc = iframe.contentWindow.document;
                      }
                      doc.open();
                      doc.writeln(data.contents);
                      doc.close();
                    }
                    return false;
                  }
              
                  window.onload = function() {
                      iframehtml();
                  }
                  function target(){
                       let iframe = $('#frame').contents(); 
                       let blankLink = iframe.find('a');
                       $(blankLink).each(function(index, val) {
                           if($(this).attr('href') != '#'){
                            $(this).attr('target','_blank');
                           }
                       });
                       
                       jQuery(iframe).find('form').attr('target','_blank');
                  }
            
                  $('#frame').on("load",function(){
                      target();
                      let iframe = $('#frame').contents(); 
                      let filtter = iframe.find('.et_pb_filterable_portfolio_grid');
                      $(filtter,'li').on("click",function(){
                          target();
                      });
                  });
          }
        
});
String.prototype.replaceAll = function (s1 = '', s2 = '') {
    return this.replace(new RegExp(s1.toString().replace(/[.^$*+?()[{\|]/g, '\\$&'), 'g'), s2.toString());
};
